import React, { useEffect, useState } from "react";
import axios from "axios";

// Signed URLs are short-lived; cache them so repeated renders don't re-request.
const cache = new Map();

export const getSignedUrl = async (file) => {
  const hit = cache.get(file);
  if (hit && hit.expires > Date.now()) return hit.url;
  const {
    data: { url, expiresIn },
  } = await axios.post("/s3/presign-download", { key: file });
  cache.set(file, { url, expires: Date.now() + (expiresIn - 30) * 1000 });
  return url;
};

export const useSignedUrl = (file) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let active = true;
    setUrl(null);
    if (file)
      getSignedUrl(file)
        .then((signed) => active && setUrl(signed))
        .catch(() => {});
    return () => {
      active = false;
    };
  }, [file]);
  return url;
};

// `file` is a stored key (or legacy URL); `component` allows a styled <img>/<a>.
export const SignedImage = ({
  file,
  component: Component = "img",
  ...props
}) => {
  const url = useSignedUrl(file);
  return url ? <Component src={url} {...props} /> : null;
};

export const SignedLink = ({
  file,
  component: Component = "a",
  children,
  ...props
}) => {
  const url = useSignedUrl(file);
  return (
    <Component href={url || undefined} {...props}>
      {children}
    </Component>
  );
};
